import services from './service'; // Service Class
let service = new services();

export default class {
    
    // Getting user's id
    getUserId() {
        let u = localStorage.getItem("cn_user");
        let user = JSON.parse(u);
        let uid = user.user_id;
        return uid;
    }

    // Getting user's token
    getUserToken() {
        let u = localStorage.getItem("cn_user");
        let user = JSON.parse(u);
        let token = user.user_token_key;
        return token;
    }
    
}


// WEBPACK FOOTER //
// ./src/services/utility.js